import "./App.less";
import React, { ReactElement, Fragment } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import routesList from "./router";

interface RouteListProps {
  path: string;
  element?: ReactElement;
  children?: any;
}

const Redirect = () => {
  window.location.replace("https://pay.mgcc.com.cn/shopping/index");
  return <></>;
};

function App() {
  // 路由列表
  const getRouteList = (list: RouteListProps[]): any => {
    return list.map((item) => {
      if (item.children) {
        return (
          <Fragment key={item.path}>
            <Route
              path={item.path}
              element={<Navigate to={item.children[0].path} replace={true} />}
            />
            {getRouteList(item.children)}
          </Fragment>
        );
      } else {
        return (
          <Route key={item.path} path={item.path} element={item.element} />
        );
      }
    });
  };

  return (
    <Routes>
      {getRouteList(routesList)}
      <Route path="*" element={<Redirect />} />
    </Routes>
  );
}

export default App;
